import { render, staticRenderFns } from "./addTrainer.vue?vue&type=template&id=3cab1030&scoped=true"
import script from "./addTrainer.vue?vue&type=script&lang=js"
export * from "./addTrainer.vue?vue&type=script&lang=js"
import style0 from "./addTrainer.vue?vue&type=style&index=0&id=3cab1030&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cab1030",
  null
  
)

export default component.exports